module.exports = __webpack_public_path__ + "img/preview-2.b94b6264.png";